export default __webpack_public_path__ + "static/11_18-f551b2be110e1482607317b602d5bd26.png";